module.exports = __webpack_public_path__ + "img/Im1.a8dbf9b1.png";